"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ADI_CHANNEL = exports.FALLBACK_FONT_TO_TEXT_PRESET_MAPPING_RESPONSIVE = exports.FALLBACK_FONT_TO_TEXT_PRESET_MAPPING = exports.FALLBACK_COLOR_TO_SITE_COLOR_MAPPING = void 0;
var types_1 = require("./types");
exports.FALLBACK_COLOR_TO_SITE_COLOR_MAPPING = {
    emptyPlayIconEditor: 'color-4',
    emptyPlayIconSite: 'color-1',
    emptyPlayerBgEditor: 'color-2',
    emptyPlayerBgSite: 'color-2',
    backgroundColor: 'color-1',
    buttonsAndLinksColor: 'color-8',
    mainButtonTextColor: 'color-1',
    textColor: 'color-5',
    dividersAndArrowsColor: 'color-3',
    mobileButtonsTextColor: 'color-1',
    mobileButtonsBackgroundColor: 'color-8',
    mainButtonColor: 'color-8',
};
exports.FALLBACK_FONT_TO_TEXT_PRESET_MAPPING = {
    textFont: types_1.TextPresetNames.BodyM,
    titleFont: types_1.TextPresetNames.HeadingL,
    videoInfoFont: types_1.TextPresetNames.HeadingS,
};
exports.FALLBACK_FONT_TO_TEXT_PRESET_MAPPING_RESPONSIVE = {
    textFont: types_1.TextPresetNames.BodyM,
    titleFont: types_1.TextPresetNames.Title,
    videoInfoFont: types_1.TextPresetNames.HeadingS,
};
exports.DEFAULT_ADI_CHANNEL = '9bf7ba3816de4423963e7d6e23c072e0';
//# sourceMappingURL=constants.js.map